import s from './styles.module.scss'

import { getAvailabilityFromDate } from './get-availability-from-date.helper'
import {
  ComputeTileDisabledProps,
  isTileDisabled,
} from './is-tile-disabled.helper'

export const computeTileClassName = (
  props: ComputeTileDisabledProps,
): string | undefined => {
  const { house, date, houseAvailabilities } = props

  if (!house) {
    return
  }

  const isHouseAvailability = Boolean(
    getAvailabilityFromDate({ date, houseAvailabilities }),
  )

  if (isTileDisabled(props) && isHouseAvailability) {
    return s.lock
  }
}
